import React, { useMemo, useState } from "react";
import "./VinylCovers.css";
import NoImage from "../../assets/no-track.avif";

export default function VinylCovers({ frontSrc, backSrc }) {
  const [broken, setBroken] = useState({
    front: false,
    back: false,
  });

  const getValidSrc = (src) => {
    const value = (src || "").trim();
    if (!value || value.toLowerCase() === "n/a") {
      return NoImage;
    }
    return value;
  };

  const images = useMemo(
    () => [
      {
        key: "front",
        label: "Front",
        src: broken.front ? NoImage : getValidSrc(frontSrc),
      },
      {
        key: "back",
        label: "Back",
        src: broken.back ? NoImage : getValidSrc(backSrc),
      },
    ],
    [frontSrc, backSrc, broken]
  );

  const [active, setActive] = useState(null);
  const [pos, setPos] = useState({ x: 50, y: 50 });
  const [popup, setPopup] = useState({ left: 0, top: 0 });

  const handleEnter = (img, e) => {
    setActive(img);

    const isMobile = window.innerWidth <= 768;

    if (isMobile) {
      setPopup({
        left: window.innerWidth / 2,
        top: window.innerHeight / 2,
      });
      return;
    }

    const rect = e.currentTarget.getBoundingClientRect();
    const popupW = 520;
    const gap = 18;

    let left = rect.right + gap;
    let top = rect.top;

    if (left + popupW > window.innerWidth - 12) {
      left = rect.left - gap - popupW;
    }

    top = Math.max(12, Math.min(top, window.innerHeight - 12 - popupW));

    setPopup({ left, top });
  };

  const handleMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;

    setPos({
      x: Math.max(0, Math.min(100, x)),
      y: Math.max(0, Math.min(100, y)),
    });
  };

  const handleLeave = () => {
    setActive(null);
  };

  return (
    <section className="vinyl-covers">
      <div className="vinyl-covers-thumbs">
        {images.map((img) => (
          <div key={img.key} className="vinyl-thumb-wrap">
            <img
              src={img.src}
              alt={img.label}
              className={`vinyl-thumb ${active?.key === img.key ? "active" : ""}`}
              onMouseEnter={(e) => handleEnter(img, e)}
              onMouseMove={handleMove}
              onMouseLeave={handleLeave}
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = NoImage;

                setBroken((prev) => ({
                  ...prev,
                  [img.key]: true,
                }));

                if (active?.key === img.key) {
                  setActive((prev) =>
                    prev ? { ...prev, src: NoImage } : prev
                  );
                }
              }}
            />
          </div>
        ))}
      </div>

      {active && (
        <div
          className="vinyl-zoomPopup"
          style={{
            left: popup.left,
            top: popup.top,
            backgroundImage: `url(${active.src})`,
            backgroundPosition: `${pos.x}% ${pos.y}%`,
          }}
        />
      )}
    </section>
  );
}